import { Button, Checkbox } from 'antd';

interface CheckboxFilterProps {
  options: string[];
  /** Selected values. Empty means no filtering, so every record is kept. */
  value: string[];
  onChange: (value: string[]) => void;
}

export const CheckboxFilter = ({ options, value, onChange }: CheckboxFilterProps) => (
  <div className="column-menu-panel">
    {options.length === 0 ? (
      <span className="px-1 py-2 text-sm text-gray-500">No options available</span>
    ) : (
      <Checkbox.Group
        className="checkbox-filter-options"
        options={options}
        value={value}
        onChange={(selected) => onChange(selected as string[])}
      />
    )}

    <Button
      type="link"
      size="small"
      className="px-0"
      disabled={value.length === 0}
      onClick={() => onChange([])}
    >
      Clear
    </Button>
  </div>
);

/** Distinct values present in `data`, alphabetically, for use as filter options. */
export const getFilterOptions = <TRecord,>(
  data: TRecord[] | undefined,
  getValue: (record: TRecord) => string
) => Array.from(new Set(data?.map(getValue) ?? [])).sort((a, b) => a.localeCompare(b));

/** Keeps records whose value is one of `selected`. An empty selection filters nothing. */
export const filterByValues = <TRecord,>(
  data: TRecord[] | undefined,
  getValue: (record: TRecord) => string,
  selected: string[]
) => (selected.length === 0 ? data : data?.filter((record) => selected.includes(getValue(record))));
